import { render, staticRenderFns } from "./BankConfirmationForm.vue?vue&type=template&id=d147934e"
import script from "./BankConfirmationForm.vue?vue&type=script&lang=js"
export * from "./BankConfirmationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports